import { PublicKey } from "@solana/web3.js";

export const GMS_PROGRAM_PUBKEY = new PublicKey("GQ51gAkEPwVouAfPXJeVcwuVwRpd5yFrrsUKWLh5UPs");
